var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestroomDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8f8f8f",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m15 33c0 1.103.897 2 2 2v2c0 1.103.897 2 2 2h4c1.103 0 2-.897 2-2v-2c1.103 0 2-.897 2-2v-2h2v-2h-2v-2c0-1.103-.897-2-2-2h-8c-1.103 0-2 .897-2 2v2h-2v2h2zm8 4h-4v-2h4zm-6-10h8l.002 6h-8.002z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m57.731 57.941c-.597-.995-1.606-1.669-2.731-1.871v-15.595c3.49-1.239 6-4.565 6-8.475v-3c0-1.103-.897-2-2-2h-14v-2h-2v2h-2v-8c0-1.103.897-2 2-2s2 .897 2 2v2h2v-2c0-2.206-1.794-4-4-4s-4 1.794-4 4v8h-4c-1.103 0-2 .897-2 2v3c0 3.91 2.51 7.236 6 8.475v15.595c-1.125.202-2.134.877-2.731 1.871l-1.835 3.059h-13.632l-1.408-6.335 3.682-.23c4.444-.278 7.924-3.983 7.924-8.435 0-1.654-1.346-3-3-3h-16.169l-3.785-20.36c-.176-.951-1.012-1.64-1.989-1.64h-3.035c-.607 0-1.177.267-1.563.73-.379.456-.534 1.051-.427 1.631l3.854 20.73v16.909h-3.886v2h61v-2h-2.434zm-22.731-25.941v-3h24v3c0 3.859-3.141 7-7 7h-10c-3.859 0-7-3.141-7-7zm7 9h10c.338 0 .671-.022 1-.059v15.059h-12v-15.059c.329.037.662.059 1 .059zm-4.017 17.971c.36-.599 1.017-.971 1.715-.971h14.604c.698 0 1.355.372 1.715.971l1.217 2.029h-20.468zm-8.983-12.971c0 .34-.034.673-.085 1h-22.027v-2h21.112c.552 0 1 .448 1 1zm-25.978-23 3.057.004 3.718 19.996h-3.093zm3.866 26h21.367c-1.02 1.93-2.99 3.294-5.304 3.438l-9.014.563.125 1.996 3.311-.207 1.38 6.21h-11.865z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m61 1h-28c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h4v-2h-4v-16h28v16h-12v2h12c1.103 0 2-.897 2-2v-16c0-1.103-.897-2-2-2z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "matrix(.707 -.707 .707 .707 3.73 32.006)",
    d: "m39.5 9.379h2v4.243h-2z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "matrix(.707 -.707 .707 .707 6.695 36.163)",
    d: "m46 4.343h2v11.314h-2z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "matrix(.707 -.707 .707 .707 9.367 39.613)",
    d: "m51.5 4.964h2v7.071h-2z",
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestroomDisabled);
export default __webpack_public_path__ + "static/media/restroom_disabled.1719a62bf1611841cb4a1e9b7430c0ba.svg";
export { ForwardRef as ReactComponent };